var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactivecustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-1219.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29)-Widgets/3)-Statistics/9)-Sales-2-Copy-6",
    transform: "translate(1206.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-3",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-user-5102256",
    transform: "translate(10.000000, 9.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9144487,12.0275665 C13.7125,12.8502376 12.2593631,13.3317966 10.6940589,13.3317966 C9.13046578,13.3317966 7.67823194,12.8518536 6.46958175,12.0409221 C6.08953897,11.7780323 5.63113118,11.6699762 5.18037072,11.7330989 C5.17368679,11.7340271 5.16626046,11.7356981 5.159577,11.7364407 C3.04698194,12.0882611 1.35434886,13.7718019 1.04336977,15.9525529 C0.703987643,18.3280282 0.279776616,21.2942829 0.0526853612,22.8879141 C-0.0221340304,23.4127715 0.134187262,23.9450434 0.481924905,24.3451385 C0.828735741,24.745975 1.33354087,24.9763647 1.86414924,24.9763647 L19.5238451,24.9763647 C20.0544534,24.9763647 20.5592538,24.7459607 20.9060694,24.3451385 C21.253807,23.9450434 21.4101093,23.4127715 21.3353089,22.8879141 C21.108251,21.2942354 20.6840257,18.3281232 20.3446245,15.9525529 C20.0336454,13.7742259 18.3435789,12.0916213 16.2358317,11.7249388 C16.2274772,11.7232679 16.2183798,11.721597 16.2092828,11.7206687 C15.7518208,11.6558731 15.2859938,11.767269 14.9076193,12.0325746 L14.9144487,12.0275665 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5161597,5.8460076 C16.5161597,9.06159696 13.9095057,11.668251 10.6939163,11.668251 C7.478327,11.668251 4.871673,9.06159696 4.871673,5.8460076 C4.871673,2.63041825 7.478327,0.0237642586 10.6939163,0.0237642586 C13.9095057,0.0237642586 16.5161597,2.63041825 16.5161597,5.8460076",
    id: "Path"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivecustomers);
export default __webpack_public_path__ + "static/media/Inactive customers.901a3e21a48b84d9fb7e26a635e7066c.svg";
export { ForwardRef as ReactComponent };